import { useCallback, useState } from "react";
import useAuthenticatorStatus from "../security/useAuthenticatorStatus";
import useStepUp from "../security/useStepUp";
import { changePassword } from "../../../services/password/passwordResetApi";
import { describeMfaError } from "../../../services/mfa/mfaErrorMessages";

// Change Password V2 (docs/specs/password-reset-stepup.md, 7b.5): the step-up is the proof, so there is no
// "current password". An ACTIVE authenticator means totp only: Oracle refuses an email token for them.
const useChangePasswordV2 = () => {
  const authenticator = useAuthenticatorStatus();
  const active = authenticator.status === "ACTIVE";
  const stepUp = useStepUp({ hasTotp: active, methods: active ? ["totp"] : ["email"] });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);

  const save = useCallback(async (newPassword) => {
    setError(null);
    const stepUpToken = await stepUp.begin();
    if (!stepUpToken) return; // the person closed the step-up
    setBusy(true);
    try {
      await changePassword({ stepUpToken, newPassword });
      setDone(true);
    } catch (e) {
      setError(describeMfaError(e).message);
    } finally {
      setBusy(false);
    }
  }, [stepUp]);

  return { authenticator, stepUp, busy, error, done, save };
};

export default useChangePasswordV2;
